import {
  //createSelector,
  createSlice,
} from '@reduxjs/toolkit';

const initialState = {
  cart_list: [],
};

export const slice = createSlice({
  name: 'userCart',
  initialState,
  reducers: {
    initUserCartList: (state) => {
      state.cart_list = [];
    },
    setUserCartList: (state, action) => {
      if (action.payload.cart_list) {
        state.cart_list = action.payload.cart_list;
      }
    },
  },
});

export const { initUserCartList, setUserCartList } = slice.actions;
export default slice.reducer;
